import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { User } from 'src/app/core/models';
import { StorageKey, StorageService } from 'src/app/core/services';
import { Gb } from 'src/app/core/services/growthbook.service';

@Directive({
  selector: '[appAdminPermission]'
})
export class AdminPermissionDirective {
  public gb: Gb;
  public currentUser: User;
  private permissions: string[] = [];

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private storageService: StorageService
  ) {
    this.gb = new Gb();
    this.currentUser = this.storageService.get(StorageKey.currentUser);
    let adminPermissions = this.storageService.get(StorageKey.adminPermissions);

    if (!this.currentUser?.adminUser && !this.currentUser?.adminManagerUser) {
      this.storageService.set(StorageKey.adminPermissions, []);
      return;
    }

    if (this.currentUser.adminManagerUser) {
      if (!adminPermissions.includes('ManageModule')) {
        adminPermissions.push('ManageModule');
        this.storageService.set(StorageKey.adminPermissions, adminPermissions);
      }
    } else {
      if (adminPermissions.includes('ManageModule')) {
        adminPermissions = adminPermissions.filter(a => a !== 'ManageModule');
        this.storageService.set(StorageKey.adminPermissions, adminPermissions);
      }
    }
  }

  @Input() set appAdminPermission(value: string | string[]) {
    this.permissions = Array.isArray(value) ? value : [value];
    this.updateView();
  }

  getPermissions(permission: string | string[]): boolean {
    const adminPermissions = this.storageService.get(StorageKey.adminPermissions);
    if (Array.isArray(permission)) {
      return permission.some(p => adminPermissions.includes(p));
    }
    return adminPermissions.includes(permission);
  }

  private async updateView() {
    if (this.currentUser?.superUser) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      return;
    }
    await this.gb.init();
    if (this.gb.isOn('EM-279')) {
      const hasAccess = this.getPermissions(this.permissions);
      this.viewContainer.clear();
      if (hasAccess) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
    } else {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
